const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim(),
    leftPanel = require('../../shop/views/left-panel.view.html').trim(),
    smartListName = 'smart',
    rewardsListName = 'mywoolworthsrewards';

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.guestList', {
            url: '/suggestedlists?{pageNumber:int}&{sortBy}',
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            onEnter: ['$state', '$stateParams', 'Settings', 'ShopperService', 'SuggestedListService', ($state, $stateParams, settings, shopperService, suggestedListService) => {
                if (settings.lists.enableListHome || !shopperService.IsGuest) {
                    $state.go('shop.list.home');
                    return;
                }
                if ($stateParams.listId) {
                    return;
                }
                // Navigate to first suggested list by default
                suggestedListService.listSuggestedLists().then(() => {
                    const firstSuggestedList = suggestedListService.suggestedLists[0];
                    // Do not keep history (replace) to prevent the user from going back to an empty page
                    $state.go('shop.suggestedlists', { listId: firstSuggestedList.ID }, { location: 'replace' });
                });
            }],
            views: {
                'left-panel@shop': {
                    template: '<wow-list-sidebar></wow-list-sidebar>',
                },
            },
            data: {
                pageMetadata: {
                    title: 'Lists - Woolworths Online',
                    metaDescription: 'Lists - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
        })
        .state('shop.suggestedlists', {
            url: '/suggestedlists/{listId:int}?{pageNumber:int}&{sortBy}',
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            views: {
                'left-panel@shop': {
                    controller: ['$stateParams', 'ListNavigationService', function ($stateParams, listNavigationService) {
                        listNavigationService.getSuggestedListMenuItems().then((menu) => {
                            this.menuItems = menu.menuItems;
                            this.menuTitle = menu.menuTitle;
                            this.menuImg = '/Images/Lists/MyList_Suggested.svg';
                        });
                    }],
                    controllerAs: '$ctrl',
                    templateProvider: ['Settings', function (settings) {
                        return settings.lists.enableListHome
                            ? `<wow-list-navigation
                                menu-items="$ctrl.menuItems"
                                menu-title="$ctrl.menuTitle"
                                img="$ctrl.menuImg">
                            </wow-list-navigation>`
                            : '<wow-list-sidebar></wow-list-sidebar>';
                    }],
                },
                'center-panel@shop': {
                    controller: ['$stateParams', function ($stateParams) {
                        this.listId = $stateParams.listId;
                        this.pageNumber = $stateParams.pageNumber || 1;
                        this.sortBy = $stateParams.sortBy;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-suggested-list-tile-list list-id="$ctrl.listId" page-number="$ctrl.pageNumber" sort-by="$ctrl.sortBy"></wow-suggested-list-tile-list>',
                },
                'rr-instrumentation-panel@root': {
                    controller: ['ShopperService', function (shopperService) {
                        this.isGuest = shopperService.IsGuest;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-rr-generic-instrumentation ng-if="!$ctrl.isGuest"></wow-rr-generic-instrumentation>',
                },
            },
        })
        .state('shop.list', {
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            data: {
                pageMetadata: {
                    title: 'Lists - Woolworths Online',
                    metaDescription: 'Lists - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
            views: {
                'left-panel@shop': {
                    controller: ['ShopperService', function (shopperService) {
                        this.shopperService = shopperService;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-list-sidebar ng-if="!$ctrl.shopperService.isGuest"></wow-list-sidebar>',
                },
            },
        })
        .state('shop.list.home', {
            url: '/mylists?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            onEnter: ['$state', 'LoginService', 'Settings', 'ShopperService', '$timeout', ($state, loginService, settings, shopperService) => {
                if (!settings.lists.enableListHome && shopperService.IsGuest) {
                    loginService.promptForLogin(loginService.LoginToContinueMessage, 'shop.list.home');
                }
            }],
            views: {
                'content@root': {
                    templateProvider: ['Settings', function (settings) {
                        return settings.lists.enableListHome ? `${centerPanel} ${rightPanel}` : `${leftPanel} ${centerPanel} ${rightPanel}`;
                    }],
                },
                'center-panel@shop.list.home': {
                    controller: ['$state', 'Settings', '$stateParams', function ($state, settings, $stateParams) {
                        this.$state = $state;
                        this.settings = settings;
                        this.pageNumber = $stateParams.pageNumber || 1;
                        this.sortBy = $stateParams.sortBy;
                    }],
                    controllerAs: '$ctrl',
                    template: `<wow-list-home ng-if="$ctrl.settings.lists.enableListHome"></wow-list-home>
                        <wow-saved-lists-default-list
                            ng-if="!$ctrl.settings.lists.enableListHome"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            filter="$ctrl.$state.params.filter">
                        </wow-saved-lists-default-list>`,
                },
                'left-panel@shop.list.home': {
                    controller: ['ShopperService', 'Settings', function (shopperService, settings) {
                        this.shopperService = shopperService;
                        this.settings = settings;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-list-sidebar ng-if="!$ctrl.settings.lists.enableListHome && !$ctrl.shopperService.isGuest"></wow-list-sidebar>',
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-wishlist-instrumentation></wow-rr-wishlist-instrumentation>',
                },
            },
        })
        .state('shop.list.reorder', {
            url: '/mylists/reorder?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            resolve: {
                useAngular2PlusQuickReorder: ['$q', '$window', 'FrontendManagementService', ($q, $window, frontendManagementService) => {
                    if (frontendManagementService.useAngular2PlusQuickReorder()) {
                        $window.location.assign('/shop/mylists/reorder'); // Go from this SPA to the Angular2+ SPA
                        return $q.reject(); // Don't continue entering this state
                    }
                    return $q.resolve();
                }],
            },
            onEnter: ['$state', 'ShopperService', 'LoginService', ($state, shopperService, loginService) => {
                if (shopperService.IsGuest) {
                    loginService.promptForLogin(loginService.LoginToContinueMessage, 'shop.list.reorder');
                }
            }],
            views: {
                'content@root': {
                    templateProvider: ['Settings', function (settings) {
                        return settings.lists.enableListHome ? `${centerPanel} ${rightPanel}` : `${leftPanel} ${centerPanel} ${rightPanel}`;
                    }],
                },
                'center-panel@shop.list.reorder': {
                    template: `
                        <wow-reorder-list></wow-reorder-list>
                    `,
                },
                'left-panel@shop.list.reorder': {
                    controller: ['ShopperService', 'Settings', function (shopperService, settings) {
                        this.shopperService = shopperService;
                        this.settings = settings;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-list-sidebar ng-if="!$ctrl.settings.lists.enableListHome && !$ctrl.shopperService.isGuest"></wow-list-sidebar>',
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-generic-instrumentation page-group="reorder" placement-ids="generic_page.quick_reorder"></wow-rr-generic-instrumentation>',
                },
            },
        })
        .state('shop.list.pastshops', {
            url: '/mylists/pastshops/{orderId}?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            onEnter: ['$state', 'Settings', 'ShopperService', ($state, settings, shopperService) => {
                if (shopperService.IsGuest) {
                    if (settings.lists.enableListHome) {
                        $state.go('shop.list.home');
                    } else {
                        $state.go('shop.guestList');
                    }
                }
            }],
            views: {
                'left-panel@shop': {
                    controller: ['$stateParams', 'ListNavigationService', 'Settings', function ($stateParams, listNavigationService, settings) {
                        if ($stateParams.orderId === 'everything') {
                            this.menuItems = [];
                            this.menuTitle = settings.lists.allProductsTitle;
                        } else {
                            listNavigationService.getPastShopsMenuItems().then((menu) => {
                                $stateParams.parent = listNavigationService.getPastShopsOrderParent(menu.menuItems, parseInt($stateParams.orderId));
                                this.menuItems = menu.menuItems;
                                this.menuTitle = menu.menuTitle;
                            });
                        }
                    }],
                    controllerAs: '$ctrl',
                    templateProvider: ['Settings', function (settings) {
                        return settings.lists.enableListHome
                            ? `<wow-list-navigation
                                menu-items="$ctrl.menuItems"
                                menu-title="$ctrl.menuTitle">
                            </wow-list-navigation>`
                            : '<wow-list-sidebar></wow-list-sidebar>';
                    }],
                },
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                        this.orderId = $state.params.orderId === 'everything' ? $state.params.orderId : parseInt($state.params.orderId);
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-past-shop-tile-list order-id="$ctrl.orderId"
                                page-number="$ctrl.$state.params.pageNumber || 1"
                                sort-by="$ctrl.$state.params.sortBy"
                                filter="$ctrl.$state.params.filter">
                            </wow-past-shop-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>',
                },
            },
        })
        .state('shop.list.edit', {
            url: '/mylists/{listId}?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            onEnter: ['$stateParams', '$state', 'Settings', 'ShopperService', ($stateParams, $state, settings, shopperService) => {
                if ($stateParams.listId.toLowerCase() !== smartListName && shopperService.IsGuest) {
                    if (settings.lists.enableListHome) {
                        $state.go('shop.list.home');
                    } else {
                        $state.go('shop.guestList');
                    }
                }
            }],
            resolve: {
                // Needed for Rewards check
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('myaccount');
                }],
            },
            views: {
                'left-panel@shop': {
                    controller: ['$stateParams', 'ListNavigationService', 'Settings', function ($stateParams, listNavigationService, settings) {
                        this.listId = parseInt($stateParams.listId);
                        this.isRewardsList = $stateParams.listId.toLowerCase() === rewardsListName;
                        this.isSmartList = $stateParams.listId.toLowerCase() === smartListName;
                        if ($stateParams.listId.toLowerCase() !== smartListName) {
                            listNavigationService.getSavedListMenuItems().then((menu) => {
                                this.menuItems = menu.menuItems;
                                this.menuTitle = menu.menuTitle;
                            });
                        } else {
                            this.menuTitle = settings.lists.smartListTitleText;
                        }
                    }],
                    controllerAs: '$ctrl',
                    templateProvider: ['Settings', function (settings) {
                        return settings.lists.enableListHome
                            ? `<wow-list-navigation
                                menu-items="$ctrl.menuItems"
                                menu-title="$ctrl.menuTitle">
                            </wow-list-navigation>`
                            : `<wow-list-sidebar ng-if="$ctrl.isSmartList"></wow-list-sidebar>
                                <wow-list-edit ng-if="!$ctrl.isSmartList"
                                    list-id="$ctrl.listId"
                                    is-rewards-list="$ctrl.isRewardsList">
                                </wow-list-edit>`;
                    }],
                },
                'center-panel@shop': {
                    controller: ['$state', 'ShopperService', 'RewardsLoginService', function ($state, shopperService, rewardsLoginService) {
                        this.$state = $state;
                        this.isRewardsList = $state.params.listId.toLowerCase() === rewardsListName;
                        this.isSmartList = $state.params.listId.toLowerCase() === smartListName;

                        // Redirect to Woolworths Rewards in My Account if they don't have one linked yet
                        if (this.isRewardsList && !shopperService.shopper.RewardsCardNumber) {
                            // Shopperservice is not reliable and may not catch some cases, so we need to do a fetch
                            rewardsLoginService.getRewardsCard().then((response) => {
                                // No response = no card
                                if (!response) {
                                    $state.go('shop.myaccount.woolworthsrewards', null, { location: 'replace' });
                                }
                            });
                        }
                    }],
                    controllerAs: '$ctrl',
                    template: `
                    <wow-tile-list-with-content ng-if="$ctrl.isSmartList">
                        <wow-smart-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-smart-list-tile-list>
                    </wow-tile-list-with-content>
                    <wow-tile-list-with-content ng-if="!$ctrl.isSmartList">
                        <wow-saved-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            list-id="$ctrl.$state.params.listId"
                            is-rewards-list="$ctrl.isRewardsList"
                            filter="$ctrl.$state.params.filter">
                        </wow-saved-list-tile-list>
                    </wow-tile-list-with-content>
                    `,
                },
            },
        })
        .state('shop.list.edit.freetext', {
            url: '/mylists/products?searchTerm',
            views: {
                'center-panel@shop': {
                    controller: ['$stateParams', function ($stateParams) {
                        this.searchTerm = $stateParams.searchTerm;
                        this.pageNumber = $stateParams.pageNumber || 1;
                        this.sortBy = $stateParams.sortBy;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-search-product-tile-list
                                search-term="$ctrl.searchTerm"
                                is-special="false"
                                is-list="true"
                                page-number="$ctrl.pageNumber"
                                sort-by="$ctrl.sortBy">
                            </wow-search-product-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/lists.js